var React = require('react');

function Transgender (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M224 240a80 80 0 1 1-80-80 80.11 80.11 0 0 1 80 80z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M372 0h-79a12 12 0 0 0-8.5 20.5l16.9 16.9-80.7 80.7A144 144 0 1 0 112 380.4V408H76a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h36v28a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-28h36a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12h-36v-27.6a144 144 0 0 0 89.9-217.1l80.7-80.7 16.9 16.9A12 12 0 0 0 384 91V12a12 12 0 0 0-12-12zM144 320a80 80 0 1 1 80-80 80 80 0 0 1-80 80z","className":"fa-primary","key":2})]);
}

Transgender.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Transgender;

Transgender.default = Transgender;
